import {
  CalendarIcon,
  FaroToggleGroup,
  FaroTooltip,
  ListViewIcon,
  ToggleItem,
  cyan,
  grey,
} from "@faro-lotv/flat-ui";
import { alpha } from "@mui/material";
import { type JSX } from "react";
import { HOVER_OPACITY } from "./calendar/calendar-styles";
import { CaptureLayout } from "./calendar/capture-calendar-types";

const LAYOUT_ITEMS: Array<ToggleItem<CaptureLayout>> = [
  { value: CaptureLayout.list, label: "Capture dates", icon: <ListViewIcon /> },
  { value: CaptureLayout.calendar, label: "Calendar", icon: <CalendarIcon /> },
];

/** MUI's dark `action.selectedOpacity` (16%), which makes the `primary/_states/selected` token */
/** Opacity of the cyan wash behind the selected layout */
const SELECTED_OPACITY = 0.16;
const PRIMARY_SELECTED = alpha(cyan[400], SELECTED_OPACITY);

/**
 * @returns flat-ui's toggle group, icons only, switching between the capture date list and
 * a calendar; restyled for the dark panel with the selected option in the primary
 * selected state and a primary icon
 * @param props The layout shown and how to change it
 */
export function LayoutToggle({
  value,
  onChange,
}: {
  value: CaptureLayout;
  onChange(layout: CaptureLayout): void;
}): JSX.Element {
  return (
    <FaroTooltip placement="top" title="Capture dates or calendar">
      <FaroToggleGroup
        items={LAYOUT_ITEMS}
        value={value}
        onChange={onChange}
        sxGroup={{ gap: 0.25, backgroundColor: grey[900] }}
        sxLabels={{ display: "none" }}
        sxIcons={{
          width: "20px",
          height: "20px",
          "& svg": { fontSize: "20px" },
        }}
        sxButtons={{
          px: 0.5,
          py: 0.25,
          backgroundColor: "transparent",
          "& [role='img']": { color: grey[300] },
          "&:hover:not(.Mui-selected)": {
            backgroundColor: alpha(grey[500], HOVER_OPACITY),
          },
          "&.Mui-selected, &.Mui-selected:hover": {
            backgroundColor: PRIMARY_SELECTED,
            boxShadow: "none",
            cursor: "default",
          },
          "&.Mui-selected [role='img'], &:hover [role='img']": {
            color: cyan[400],
          },
        }}
      />
    </FaroTooltip>
  );
}
